import './Classic.css';
import classicBackgroundImg from '../../images/classicBackgroundImg.png';
import { Button } from '../../components/buttons/Button/Button';
import { classicButtons } from './constantsClassic';
import { Outlet } from 'react-router-dom';
import React from 'react';
import { Title } from '../../components/Title/Title';

export const Classic = () => {
    const title = 'Классик';
    return (
        <div className="classic">
            <Title title={title} />
            <img src={classicBackgroundImg} alt="" className="classic__background-img" />
            <span className="classic__background-text">
                Раунд #<span>5104661</span>
            </span>
            <div className="classic__secure-container">
                {classicButtons.map((item, i) => (
                    <Button link={item.link} key={i} icon={item.icon} />
                ))}
            </div>
            <Outlet />
        </div>
    );
};
